import React from "react";

// { songs, loading, newCount, markSeen } - a single app-wide poll of
// pending song proposals, shared by Navigationbar (so the "new
// proposal" badge on the Proposals tab stays accurate no matter which
// page the user is actually on). Mirrors UpcomingEventsContext.
const SongProposalsContext = React.createContext();

export { SongProposalsContext };
